<template>
  <div>
    <el-form
      v-if="isShow"
      ref="rowForm"
      :model="rowData"
      label-width="110px"
      class="demo-ruleForm"
      :rules="rules"
    >
      <el-form-item label="员工账号" prop="username">
        <span v-if="readonly" class="read-content">{{ rowData.username }}</span>
        <el-input
          v-else
          v-model="rowData.username"
          :readonly="pageFlag == 2"
        />
      </el-form-item>
      <el-form-item
        v-if="pageFlag == 3"
        label="登录密码"
        prop="password"
        :readonly="readonly"
      >
        <span v-if="readonly" class="read-content">{{ rowData.password }}</span>
        <el-input v-else v-model="rowData.password" />
      </el-form-item>
      <el-form-item label="员工姓名" prop="realname" :readonly="readonly">
        <span v-if="readonly" class="read-content">{{ rowData.realname }}</span>
        <el-input v-else v-model="rowData.realname" />
      </el-form-item>
      <el-form-item label="员工角色" prop="roleId" :readonly="readonly">
        <span v-if="readonly" class="read-content">{{ getroleName }}</span>
        <el-select
          v-else
          v-model="rowData.roleId"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in roleNameData"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile" :readonly="readonly">
        <span v-if="readonly" class="read-content">{{ rowData.mobile }}</span>
        <el-input v-else v-model="rowData.mobile" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    rowForm: Object,
    pageFlag: String || Number,
    readonly: Boolean,
    pageTitle: String,
    roleNameData: Array,
    isCreate: Boolean
  },
  data () {
    const phoneNumCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }

      setTimeout(() => {
        var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/g
        if (!reg.test(value)) {
          reg.lastIndex = 0
          callback(new Error('请写正确的手机号'))
        }
        callback()
        reg.lastIndex = 0
      }, 700)
    }

    const nickNameCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        const reg = /^[0-9A-Za-z]+$/

        if (!reg.test(value)) {
          callback(new Error('必须是数字、英文字母'))
        } else if (value.length > 20 || value.length < 4) {
          callback(new Error('长度在 4 到 20 '))
        } else {
          callback()
        }
      }, 500)
    }
    const passwordCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        const reg = /^[0-9A-Za-z]+$/

        if (!reg.test(value)) {
          callback(new Error('必须是数字、英文字母'))
        } else if (value.length > 20 || value.length < 6) {
          callback(new Error('长度在 6 到 20 '))
        } else {
          callback()
        }
      }, 500)
    }
    const realNameCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      setTimeout(() => {
        const reg = /^[0-9A-Za-z_\u4e00-\u9fa5]+$/
        if (!reg.test(value)) {
          callback(new Error('必须是汉字、数字或英文字母'))
        } else if (value.length > 20 || value.length < 2) {
          callback(new Error('长度在 2 到 20 '))
        } else {
          callback()
        }
      }, 500)
    }

    return {
      rowData: {
        username: '',
        password: '123456',
        realname: '',
        mobile: '',
        status: '1',
        roleId: '',
        groupNum: 1
      },
      lineData: [],
      rules: {
        username: [
          { required: true, message: '请输入员工账号', trigger: 'blur' },
          {
            min: 4,
            max: 20,
            message: '长度在 4 到 20',
            trigger: 'blur'
          },
          {
            validator: nickNameCheck,
            trigger: 'blur'
          }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: passwordCheck, trigger: 'blur' }],
        realname: [
          {
            type: 'string',
            required: true,
            message: '请输入员工姓名',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 10,
            message: '不能为空,长度不大于10',
            trigger: 'blur'
          },
          {
            validator: realNameCheck,
            trigger: 'blur'
          }
        ],
        roleId: [
          {
            // type: 'array',
            type: 'number',
            required: true,
            message: '请选择员工角色',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: phoneNumCheck,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    getroleName () {
      return [this.rowData.roleId]
        .reduce((total, item) => {
          const target = this.roleNameData.find(
            (roleItem) => roleItem.roleId === item
          )
          target && total.push(target.roleName)
          return total
        }, [])
        .join()
    },
    isShow () {
      return this.isCreate || this.rowForm
    }
  },
  mounted () {
    if (this.rowForm) {
      this.rowData = this.rowForm
    }
  },
  updated () {
    if (this.rowForm) {
      this.rowData = this.rowForm
    }
  }
}
</script>

<style lang="scss" scoped>
.read-content {
  display: inline-block;
  border: 1px solid #dcdfe6;
  width: 100%;
  height: 38px;
  border-radius: 5px;
  padding: 0 15px;
}
</style>
